import React, { Dispatch, useState } from 'react';
import { Col, Row, Form, DatePicker, Collapse } from 'antd';
import { Action } from 'typesafe-actions';
import { useDispatch, useSelector } from 'react-redux';
import { CALENDAR_LOCALE } from '../../../utils/calendar-locale';
import FilterContainer from '../../../components/FilterContainer';
import { ApplicationState } from '../../../store';
import CollapseTitle from '../../../components/TitleCollapseFilter';
import FilterBtn from '../../../components/FilterBtn';
import ClearFilterBtn from '../../../components/ClearFilterBtn';
import CollapseFilter from '../../../components/CollapseFilter';
import SelectEmbarcador from '../../../components/SelectEmbarcador';
import SelectNumNota from '../../../components/SelectNumNota';
import SelectProtocolo from '../../../components/SelectProtocolo';
import SelectStatus from '../../../components/SelectStatus';
import SelectTipoSolicitacao from '../../../components/SelectTipoSolicitacao';
import SelectAtendente from '../../../components/SelectAtendente';
import SelectUrgencia from '../../../components/SelectUrgencia';
import moment from 'moment';
import {
  filterAtendimentos,
  loadRequest,
  cleanStateAtendimentos,
} from '../../../store/ducks/atendimentos/actions';
import TextFilter from '../../../components/TextFilter';

const Filter: React.FC = () => {
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth?.cddAtivo);
  const pagCurrent = useSelector(
    (state: ApplicationState) => state.Atendimentos.pagination.current
  );
  const sorter = useSelector((state: ApplicationState) => state.Atendimentos.sorter);
  const [filter, setFilter] = useState<object | undefined | any>();
  const { RangePicker } = DatePicker;
  const { Panel } = Collapse;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_embarcador, setEmbarcador] = useState<string>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_numNota, setNumNota] = useState<number>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_protocolo, setProtocolo] = useState<number>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_tipoSolicitacao, setTipoSolicitacao] = useState<string>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_atendente, setAtendente] = useState<string>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_urgencia, setUrgencia] = useState<string>();
  const dispatch = useDispatch<Dispatch<Action>>();

  const clearFilter = () => {
    localStorage.removeItem(`embarcador${window.location.pathname}`);
    localStorage.removeItem(`numNota${window.location.pathname}`);
    localStorage.removeItem(`protocolo${window.location.pathname}`);
    localStorage.removeItem(`status${window.location.pathname}`);
    localStorage.removeItem(`tipoSolicitacao${window.location.pathname}`);
    localStorage.removeItem(`atendente${window.location.pathname}`);
    localStorage.removeItem(`urgencia${window.location.pathname}`);
    localStorage.removeItem(window.location.pathname + `valuesFilter`);
    dispatch(cleanStateAtendimentos());
    setTimeout(() => {
      dispatch(loadRequest(undefined, inscricaoAtiva, cddAtivo?.codCdd as number));
    }, 0);
  };

  const onFilter = (values: any) => {
    const { dtAtendimento, ...rest } = values;
    let dataAbertura, dataConclusao;

    if (dtAtendimento) [dataAbertura, dataConclusao] = dtAtendimento;

    Object.keys(values).forEach((key) => {
      if (values[key] === undefined || values[key] === null || values[key] === '') {
        delete values[key];
      }
    });

    setFilter({
      ...rest,
      dtAberturaIni: dataAbertura ? moment(dataAbertura).format() : undefined,
      dtAberturaFim: dataConclusao ? moment(dataConclusao).format() : undefined,
    });
  };

  const localStorageItensPersist: any = JSON.parse(
    localStorage.getItem(window.location.pathname + `valuesFilter`) || '{}'
  );
  const { atendimentoDataAbertura, atendimentoDataConclusao } = localStorageItensPersist;

  return (
    <CollapseFilter
      filter={filter}
      pagination={pagCurrent}
      sorter={sorter}
      loadRequest={loadRequest}
      saveFilter={filterAtendimentos}
      saveLocalStorage={'persist:Atendimentos'}
    >
      <Panel header={<CollapseTitle>Filtro</CollapseTitle>} key="1">
        <FilterContainer
          onFilter={onFilter}
          initialValues={{
            ...localStorageItensPersist,
            atendimentoDataAbertura: atendimentoDataAbertura
              ? moment(atendimentoDataAbertura, 'DD/MM/YYYY')
              : undefined,
            atendimentoDataConclusao: atendimentoDataConclusao
              ? moment(atendimentoDataConclusao, 'DD/MM/YYYY')
              : undefined,
          }}
        >
          <Row gutter={24}>
            <Col md={6} sm={24} xs={24}>
              <SelectEmbarcador setEmbarcador={setEmbarcador} />
            </Col>

            <Col md={6} sm={24} xs={24}>
              <SelectNumNota setNumNotas={setNumNota} />
            </Col>

            <Col md={6} sm={24} xs={24}>
              <SelectProtocolo setProtocolo={setProtocolo} />
            </Col>

            <Col md={6} sm={24} xs={24}>
              <SelectStatus />
            </Col>
          </Row>

          <Row gutter={24}>
            <Col md={6} sm={24} xs={24}>
              <SelectTipoSolicitacao required={false} setTipoSolicitacao={setTipoSolicitacao} />
            </Col>

            <Col md={6} sm={24} xs={24}>
              <Form.Item
                label={<TextFilter>Período de abertura do atendimento</TextFilter>}
                name="dtAtendimento"
              >
                {atendimentoDataAbertura === undefined ? (
                  <RangePicker
                    style={{ width: '100%' }}
                    locale={CALENDAR_LOCALE}
                    format="DD/MM/YYYY"
                  />
                ) : (
                  <RangePicker
                    style={{ width: '100%' }}
                    locale={CALENDAR_LOCALE}
                    format="DD/MM/YYYY"
                    defaultValue={[
                      moment(atendimentoDataAbertura, 'DD/MM/YYYY'),
                      moment(atendimentoDataConclusao, 'DD/MM/YYYY'),
                    ]}
                  />
                )}
              </Form.Item>
            </Col>

            <Col md={6} sm={24} xs={24}>
              <SelectAtendente setAtendente={setAtendente} />
            </Col>

            <Col md={6} sm={24} xs={24}>
              <SelectUrgencia setUrgencia={setUrgencia} />
            </Col>
          </Row>
          <Row gutter={24} justify="end">
            <Col md={6} sm={24} xs={24}>
              <ClearFilterBtn onClick={clearFilter}>Limpar filtros</ClearFilterBtn>
            </Col>
            <Col md={6} sm={24} xs={24}>
              <FilterBtn>Filtrar</FilterBtn>
            </Col>
          </Row>
        </FilterContainer>
      </Panel>
    </CollapseFilter>
  );
};

export default Filter;
